import styled from "@emotion/styled";
export const StyledItemsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: -32px;
  justify-content: space-between;
  max-width: 760px;

  .item-wrapper {
    margin-bottom: 48px;
  }
`;
